var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNachos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -80.711 271.222)",
    gradientUnits: "userSpaceOnUse",
    x1: 253.305,
    x2: 425.275,
    xlinkHref: "#lg1",
    y1: 113.277,
    y2: 285.247
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#fe922f",
    stopOpacity: 0.262
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6897,
    stopColor: "#fe8417",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7701"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -80.711 271.222)",
    gradientUnits: "userSpaceOnUse",
    x1: 398.604,
    x2: 398.604,
    xlinkHref: "#lg2",
    y1: 113.841,
    y2: 149.333
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -80.711 271.222)",
    gradientUnits: "userSpaceOnUse",
    x1: 382.97,
    x2: 382.97,
    xlinkHref: "#lg2",
    y1: 225.507,
    y2: 260.999
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -80.711 271.222)",
    gradientUnits: "userSpaceOnUse",
    x1: 349.551,
    x2: 349.551,
    xlinkHref: "#lg2",
    y1: 55.521,
    y2: 115.983
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -80.711 271.222)",
    gradientUnits: "userSpaceOnUse",
    x1: 300.697,
    x2: 300.697,
    xlinkHref: "#lg2",
    y1: 181.704,
    y2: 242.166
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -80.711 271.222)",
    gradientUnits: "userSpaceOnUse",
    x1: 470.979,
    x2: 470.979,
    xlinkHref: "#lg2",
    y1: 207.246,
    y2: 267.708
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -80.711 271.222)",
    gradientUnits: "userSpaceOnUse",
    x1: 365.941,
    x2: 365.941,
    xlinkHref: "#lg2",
    y1: 248.776,
    y2: 306.782
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.197,
    x2: 281.53,
    y1: 195.767,
    y2: 223.101
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c0272d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.47,
    x2: 293.809,
    xlinkHref: "#lg1",
    y1: 268.467,
    y2: 473.807
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.639,
    x2: 235.305,
    xlinkHref: "#lg2",
    y1: 370.681,
    y2: 248.681
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 353.534,
    x2: 274.867,
    xlinkHref: "#lg2",
    y1: 312.562,
    y2: 277.896
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe646f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb2b3a"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.277,
    x2: 279.944,
    xlinkHref: "#lg3",
    y1: 182.959,
    y2: 291.625
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.734,
    x2: 237.633,
    xlinkHref: "#lg3",
    y1: 153.154,
    y2: 200.053
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 184.057,
    x2: 184.057,
    xlinkHref: "#lg2",
    y1: 360.128,
    y2: 402.507
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.546,
    x2: 350.546,
    xlinkHref: "#lg2",
    y1: 416.603,
    y2: 458.982
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.057,
    x2: 118.057,
    xlinkHref: "#lg2",
    y1: 311.505,
    y2: 383.699
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 179.057,
    x2: 179.057,
    xlinkHref: "#lg2",
    y1: 413.505,
    y2: 485.699
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.047,
    x2: 313.047,
    xlinkHref: "#lg2",
    y1: 328.004,
    y2: 400.198
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.961,
    x2: 222.961,
    xlinkHref: "#lg2",
    y1: 430.259,
    y2: 499.52
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 402.09,
    x2: 434.09,
    xlinkHref: "#lg1",
    y1: 283.076,
    y2: 324.076
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.09,
    x2: 150.09,
    xlinkHref: "#lg1",
    y1: 100.076,
    y2: 141.076
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 430,
    x2: 430,
    xlinkHref: "#lg1",
    y1: 233.725,
    y2: 275.064
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m166.757 67.281 47.583 232.315c8.953 43.71 62.926 59.916 94.476 28.366l184.732-184.732c31.549-31.549 15.344-85.523-28.366-94.476l-232.315-47.582c-39.373-8.064-74.174 26.737-66.11 66.109z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 293.95,
    cy: 82.173,
    fill: "url(#SVGID_2_)",
    r: 15.928
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361.856,
    cy: 172.188,
    fill: "url(#SVGID_3_)",
    r: 15.928
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.686,
    cy: 84.28,
    fill: "url(#SVGID_4_)",
    r: 27.134
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.366,
    cy: 208.05,
    fill: "url(#SVGID_5_)",
    r: 27.134
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.835,
    cy: 105.703,
    fill: "url(#SVGID_6_)",
    r: 27.134
  })), /*#__PURE__*/React.createElement("path", {
    d: "m214.34 299.596c8.953 43.71 62.926 59.916 94.476 28.366l184.732-184.732c31.549-31.549 15.344-85.523-28.366-94.476l-16.735-3.428-237.535 237.535z",
    fill: "url(#SVGID_7_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m277.042 156.583h-91.994l29.292 143.013c8.953 43.71 62.926 59.916 94.476 28.366l69.803-69.803z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m167.144 169.962-155.971 236.321c-29.346 44.464 2.542 103.717 55.817 103.717h311.944c53.275 0 85.163-59.253 55.817-103.717l-155.973-236.321c-26.434-40.052-85.199-40.052-111.634 0z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.75 406.283-155.972-236.321c-26.434-40.052-85.2-40.052-111.634 0l-32.461 49.183c.468 2.102 1.351 4.129 2.669 5.944 2.197 3.025 4.55 5.93 7.046 8.704 2.984 3.316 4.672 7.596 4.67 12.057l-.017 39.719c0 6.807 3.596 12.759 8.981 16.106l208.325 208.325h12.577c53.274 0 85.162-59.253 55.816-103.717z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.778 169.962c-4.429-6.71-9.768-12.291-15.708-16.752l-.019 132.36c0 6.156 2.945 11.611 7.488 15.077l169.545 169.545c8.706-19.576 8.25-43.325-5.334-63.908z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m309.519 224.169c-9.885 13.577-22.887 24.74-37.957 32.434-5.921 3.023-9.573 9.19-9.575 15.838l-.026 68.838c0 5.23-2.13 9.97-5.56 13.4s-8.17 5.55-13.4 5.55c-10.47-.01-18.95-8.5-18.95-18.97v-56.333c0-8.958-6.625-16.522-15.501-17.728-.624-.085-1.247-.175-1.868-.269-10.883-1.658-20.716 6.653-20.72 17.661 0 5.23-2.13 9.97-5.56 13.4s-8.17 5.55-13.4 5.55c-10.47-.01-18.95-8.5-18.95-18.97l.017-39.719c.002-4.461-1.686-8.741-4.67-12.057-2.496-2.774-4.849-5.679-7.046-8.704-3.956-5.447-4.083-12.79-.375-18.409l28.484-43.162c27.71-41.97 89.29-41.97 117 0l28.487 43.162c3.727 5.648 3.553 13.017-.43 18.488z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.961 232.259c7.954 0 14.705-.868 22.164-2.515 8.174-1.804 15.947 4.29 15.943 12.66l-.017 42.168c-.006 10.468 9.476 18.959 19.945 18.965 10.468.006 18.959-8.476 18.965-18.945l.033-85.079c2.063-2.107 2.329-5.385.707-7.841l-19.241-29.152c-27.71-41.97-89.29-41.97-117 0-14.774 22.387-5.226 52.802 19.775 62.515 12.01 4.665 25.069 7.224 38.726 7.224z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 184.057,
    cy: 380.913,
    fill: "url(#SVGID_14_)",
    r: 19.019
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.546,
    cy: 437.388,
    fill: "url(#SVGID_15_)",
    r: 19.019
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.057,
    cy: 346.913,
    fill: "url(#SVGID_16_)",
    r: 32.399
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.057,
    cy: 448.913,
    fill: "url(#SVGID_17_)",
    r: 32.399
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.047,
    cy: 363.412,
    fill: "url(#SVGID_18_)",
    r: 32.399
  })), /*#__PURE__*/React.createElement("path", {
    d: "m11.173 406.283c-29.346 44.464 2.542 103.717 55.817 103.717h311.944c53.275 0 85.163-59.253 55.817-103.717l-11.236-17.024h-401.107z",
    fill: "url(#SVGID_19_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m404.16 298.696 14.262-9.74c6.45-4.405 15.244-.135 15.772 7.657l1.391 20.524c.572 8.431-8.847 13.794-15.806 9l-15.654-10.784c-5.84-4.024-5.823-12.657.035-16.657z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.16 115.696 14.262-9.74c6.45-4.405 15.244-.135 15.772 7.657l1.391 20.524c.572 8.431-8.847 13.794-15.806 9l-15.654-10.784c-5.84-4.024-5.823-12.657.035-16.657z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 254,
    fill: "url(#SVGID_22_)",
    r: 18.552
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNachos);
export default __webpack_public_path__ + "static/media/icon-nachos.eff274dddb1c92b857ea1f1d39a75835.svg";
export { ForwardRef as ReactComponent };